import React from 'react';
import './HelpModal.css';
import { FaTimes, FaEnvelope, FaUserTie, FaTools } from 'react-icons/fa';

function HelpModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="help-modal-overlay">
      <div className="help-modal-content">
        <button className="help-modal-close" onClick={onClose} title="Cerrar">
          <FaTimes />
        </button>
        <h2 className="help-modal-title">¿Necesitas ayuda?</h2>
        <div className="help-modal-section">
          <div className="help-modal-section-header">
            <FaUserTie className="help-modal-icon" /> Para ayuda con tus datos:
          </div>
          <div className="help-modal-section-body">
            Contacta a <strong>Rosy García</strong> a través de Microsoft Teams<br />
            o envíale un correo a <a href="mailto:rosy.garcia@wsp.com.mx">rosy.garcia@wsp.com.mx</a>
          </div>
        </div>
        <div className="help-modal-section">
          <div className="help-modal-section-header">
            <FaTools className="help-modal-icon" /> Para ayuda técnica:
          </div>
          <div className="help-modal-section-body">
            Contacta a <strong>Fernando Núñez</strong> a través de Microsoft Teams<br />
            o envíale un correo a <a href="mailto:fernando.nunez@wsp.com.mx">fernando.nunez@wsp.com.mx</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpModal; 